import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const SETTING_COLOR = '#1E64CC';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      '& .MuiDialog-paper': {
        maxWidth: theme.spacing(129), // 1032px
      },
    },
    wrapper: {
      padding: theme.spacing(3),
    },
    content: {
      paddingTop: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      gap: theme.spacing(4),
    },

    controls: {
      display: 'flex',
      gap: theme.spacing(2),
      alignItems: 'center',
      '& > .MuiFormControl-root': {
        width: theme.spacing(35),
      },
      '& > .MuiInputBase-input': {
        display: 'flex',
        alignItems: 'center',
      },
    },
    select: {
      '& > .MuiSelect-select': {
        display: 'flex',
        alignItems: 'center',
      },
    },
    menuItem: {
      backgroundColor: 'transparent!important',
    },
    checkbox: {
      padding: 0,
      marginRight: 1,
      color: '#000',
      '&.Mui-checked': {
        color: '#000',
      },
    },
    selectTimeframe: {
      '& > .MuiSelect-select': {
        padding: theme.spacing(2, 1),
      },
      '& > .MuiSelect-select:focus': {
        padding: theme.spacing(2, 1),
      },
    },
    clientSettings: {
      display: 'flex',
      justifyContent: 'space-between',
      color: theme.palette.primary.dark,
      padding: theme.spacing(2, 2),
    },
    clientText: {
      cursor: 'pointer',
    },

    dateInput: {
      maxWidth: theme.spacing(22.5),
      '& .MuiInputBase-input': {
        padding: theme.spacing(1.625, 1.5),
        fontSize: theme.typography.body2.fontSize,
      },
      textAlign: 'right',
      '& .MuiInputAdornment-root': {
        cursor: 'pointer',
      },
    },
    menuList: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      maxHeight: theme.spacing(38),
      overflow: 'auto',
      backgroundColor: theme.palette.grey[100],
    },
    renderLabel: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    searchField: {
      padding: theme.spacing(0, 1),
    },
    customReportWrapper: {
      backgroundColor: theme.palette.grey[100],
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    reportNameField: {
      '& .MuiInputBase-root': {
        height: theme.spacing(6),
        fontSize: theme.spacing(1.75),
      },
      width: theme.spacing(77),
    },
    action: {
      justifyContent: 'flex-end',
      gap: theme.spacing(1.5),
      paddingTop: theme.spacing(4),
      paddingRight: 0,
    },
  })
);
